export function resetCardPointerState(shellElement: HTMLElement) {
  const element =
    shellElement.querySelector<HTMLElement>(".model-card-tilt");
  delete shellElement.dataset.wheelActive;
  if (!element) return;

  delete element.dataset.active;
  element.style.setProperty("--tilt-x", "0deg");
  element.style.setProperty("--tilt-y", "0deg");
  element.style.setProperty("--tilt-scale", "1");
  element.style.setProperty("--card-shadow-x", "0px");
  element.style.setProperty("--card-shadow-y", "6px");
}
